// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 4 10", width: "4", height: "10" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", { transform: "translate(-314 -398)" },
                React.createElement("rect", { width: 4, height: 10, x: 314, y: 398, rx: 2 })))));
};
Icon.displayName = 'Nub4x10';
export default Icon;
//# sourceMappingURL=Nub4x10.js.map